import { useInputCounterContext } from '../../input-counter'
import type { InputCounterScopedProps } from '../../input-counter.types'
import { InputCounterControlVariants } from './input-counter-control.styles'

type InputCounterControlProps = {
  children: React.ReactNode
}

export const InputCounterControl = (props: InputCounterControlProps) => {
  const { children, __scopeInputCounter } =
    props as InputCounterScopedProps<InputCounterControlProps>

  const { size, disabled, hasError, readOnly, currentValue } =
    useInputCounterContext('InputCounterControl', __scopeInputCounter)

  const hasFilled = currentValue >= 1
  return (
    <div
      className={InputCounterControlVariants({
        size,
        disabled,
        hasError,
        readOnly,
        hasFilled,
      })}
    >
      {children}
    </div>
  )
}
